import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _667199cc = () => interopDefault(import('../pages/certification.vue' /* webpackChunkName: "pages/certification" */))
const _86277e50 = () => interopDefault(import('../pages/class.vue' /* webpackChunkName: "pages/class" */))
const _be6a754a = () => interopDefault(import('../pages/class/index.vue' /* webpackChunkName: "pages/class/index" */))
const _58068d9a = () => interopDefault(import('../pages/class/closed.vue' /* webpackChunkName: "pages/class/closed" */))
const _b37723d6 = () => interopDefault(import('../pages/config/index.vue' /* webpackChunkName: "pages/config/index" */))
const _405fa618 = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _696a65c4 = () => interopDefault(import('../pages/errorsBook.vue' /* webpackChunkName: "pages/errorsBook" */))
const _713aa96f = () => interopDefault(import('../pages/exam.vue' /* webpackChunkName: "pages/exam" */))
const _486aadb1 = () => interopDefault(import('../pages/exam/correction/index.vue' /* webpackChunkName: "pages/exam/correction/index" */))
const _eb0aa718 = () => interopDefault(import('../pages/exam/distribute/index.vue' /* webpackChunkName: "pages/exam/distribute/index" */))
const _06eaaad2 = () => interopDefault(import('../pages/exam/exams/index.vue' /* webpackChunkName: "pages/exam/exams/index" */))
const _1eaeeb89 = () => interopDefault(import('../pages/exam/correction/correct.vue' /* webpackChunkName: "pages/exam/correction/correct" */))
const _4ce31e8e = () => interopDefault(import('../pages/exam/correction/correct/_id/coments.vue' /* webpackChunkName: "pages/exam/correction/correct/_id/coments" */))
const _b49c086c = () => interopDefault(import('../pages/exam/correction/correct/_id/exam.vue' /* webpackChunkName: "pages/exam/correction/correct/_id/exam" */))
const _a39d7dd2 = () => interopDefault(import('../pages/exam/correction/selectExam/_id.vue' /* webpackChunkName: "pages/exam/correction/selectExam/_id" */))
const _e50b2f4e = () => interopDefault(import('../pages/exam/correction/_id.vue' /* webpackChunkName: "pages/exam/correction/_id" */))
const _11f13bdc = () => interopDefault(import('../pages/exam/distribute/_id.vue' /* webpackChunkName: "pages/exam/distribute/_id" */))
const _132066bf = () => interopDefault(import('../pages/exam/exams/_id.vue' /* webpackChunkName: "pages/exam/exams/_id" */))
const _3f1d5a7e = () => interopDefault(import('../pages/exam/ranking/_id.vue' /* webpackChunkName: "pages/exam/ranking/_id" */))
const _c8a7f830 = () => interopDefault(import('../pages/IA.vue' /* webpackChunkName: "pages/IA" */))
const _c5408ce8 = () => interopDefault(import('../pages/materials.vue' /* webpackChunkName: "pages/materials" */))
const _3ca5e70f = () => interopDefault(import('../pages/materials/index.vue' /* webpackChunkName: "pages/materials/index" */))
const _71f81256 = () => interopDefault(import('../pages/materials/_catId/_subId.vue' /* webpackChunkName: "pages/materials/_catId/_subId" */))
const _75ee0331 = () => interopDefault(import('../pages/messagewall.vue' /* webpackChunkName: "pages/messagewall" */))
const _73708bb4 = () => interopDefault(import('../pages/resultados.vue' /* webpackChunkName: "pages/resultados" */))
const _65db219f = () => interopDefault(import('../pages/resultados/_id/comparativo.vue' /* webpackChunkName: "pages/resultados/_id/comparativo" */))
const _01c71c62 = () => interopDefault(import('../pages/resultados/_id/geral.vue' /* webpackChunkName: "pages/resultados/_id/geral" */))
const _5764acc6 = () => interopDefault(import('../pages/resultados/_id/questions.vue' /* webpackChunkName: "pages/resultados/_id/questions" */))
const _e0fb1656 = () => interopDefault(import('../pages/simulados.vue' /* webpackChunkName: "pages/simulados" */))
const _5f9170d0 = () => interopDefault(import('../pages/simulados/index.vue' /* webpackChunkName: "pages/simulados/index" */))
const _5e45d6c3 = () => interopDefault(import('../pages/simulados/simulatedResult.vue' /* webpackChunkName: "pages/simulados/simulatedResult" */))
const _8ad595b2 = () => interopDefault(import('../pages/simulados/ranking/_id.vue' /* webpackChunkName: "pages/simulados/ranking/_id" */))
const _bf8f319a = () => interopDefault(import('../pages/suport.vue' /* webpackChunkName: "pages/suport" */))
const _548d0914 = () => interopDefault(import('../pages/suport/index.vue' /* webpackChunkName: "pages/suport/index" */))
const _641e2e04 = () => interopDefault(import('../pages/suport/resolved.vue' /* webpackChunkName: "pages/suport/resolved" */))
const _d5b30bb0 = () => interopDefault(import('../pages/videos.vue' /* webpackChunkName: "pages/videos" */))
const _9eae7aaa = () => interopDefault(import('../pages/videos/index.vue' /* webpackChunkName: "pages/videos/index" */))
const _5675f134 = () => interopDefault(import('../pages/videos/_catId/_id.vue' /* webpackChunkName: "pages/videos/_catId/_id" */))
const _77e153c0 = () => interopDefault(import('../pages/applySimulated/print.vue' /* webpackChunkName: "pages/applySimulated/print" */))
const _736b8fb0 = () => interopDefault(import('../pages/config/password.vue' /* webpackChunkName: "pages/config/password" */))
const _755d3a4c = () => interopDefault(import('../pages/config/payment/index.vue' /* webpackChunkName: "pages/config/payment/index" */))
const _66ca8019 = () => interopDefault(import('../pages/config/perfil.vue' /* webpackChunkName: "pages/config/perfil" */))
const _cd24ecf4 = () => interopDefault(import('../pages/config/payment/card.vue' /* webpackChunkName: "pages/config/payment/card" */))
const _d25856e4 = () => interopDefault(import('../pages/config/payment/history.vue' /* webpackChunkName: "pages/config/payment/history" */))
const _2b384f37 = () => interopDefault(import('../pages/config/payment/_id/index.vue' /* webpackChunkName: "pages/config/payment/_id/index" */))
const _49eeabf6 = () => interopDefault(import('../pages/config/payment/_id/unsubscribe.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe" */))
const _520be1f9 = () => interopDefault(import('../pages/config/payment/_id/unsubscribe/index.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe/index" */))
const _cd82e444 = () => interopDefault(import('../pages/config/payment/_id/unsubscribe/confirmation.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe/confirmation" */))
const _bc395e2c = () => interopDefault(import('../pages/config/payment/_id/unsubscribe/success.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe/success" */))
const _cf5a3d26 = () => interopDefault(import('../pages/applySimulated/_id.vue' /* webpackChunkName: "pages/applySimulated/_id" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3d17928a = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/certification",
    component: _667199cc,
    name: "certification"
  }, {
    path: "/class",
    component: _86277e50,
    children: [{
      path: "",
      component: _be6a754a,
      name: "class"
    }, {
      path: "closed",
      component: _58068d9a,
      name: "class-closed"
    }]
  }, {
    path: "/config",
    component: _b37723d6,
    name: "config"
  }, {
    path: "/documents",
    component: _405fa618,
    name: "documents"
  }, {
    path: "/errorsBook",
    component: _696a65c4,
    name: "errorsBook"
  }, {
    path: "/exam",
    component: _713aa96f,
    name: "exam",
    children: [{
      path: "correction",
      component: _486aadb1,
      name: "exam-correction"
    }, {
      path: "distribute",
      component: _eb0aa718,
      name: "exam-distribute"
    }, {
      path: "exams",
      component: _06eaaad2,
      name: "exam-exams"
    }, {
      path: "correction/correct",
      component: _1eaeeb89,
      name: "exam-correction-correct",
      children: [{
        path: ":id?/coments",
        component: _4ce31e8e,
        name: "exam-correction-correct-id-coments"
      }, {
        path: ":id?/exam",
        component: _b49c086c,
        name: "exam-correction-correct-id-exam"
      }]
    }, {
      path: "correction/selectExam/:id?",
      component: _a39d7dd2,
      name: "exam-correction-selectExam-id"
    }, {
      path: "correction/:id",
      component: _e50b2f4e,
      name: "exam-correction-id"
    }, {
      path: "distribute/:id",
      component: _11f13bdc,
      name: "exam-distribute-id"
    }, {
      path: "exams/:id",
      component: _132066bf,
      name: "exam-exams-id"
    }, {
      path: "ranking/:id?",
      component: _3f1d5a7e,
      name: "exam-ranking-id"
    }]
  }, {
    path: "/IA",
    component: _c8a7f830,
    name: "IA"
  }, {
    path: "/materials",
    component: _c5408ce8,
    children: [{
      path: "",
      component: _3ca5e70f,
      name: "materials"
    }, {
      path: ":catId/:subId?",
      component: _71f81256,
      name: "materials-catId-subId"
    }]
  }, {
    path: "/messagewall",
    component: _75ee0331,
    name: "messagewall"
  }, {
    path: "/resultados",
    component: _73708bb4,
    name: "resultados",
    children: [{
      path: ":id?/comparativo",
      component: _65db219f,
      name: "resultados-id-comparativo"
    }, {
      path: ":id?/geral",
      component: _01c71c62,
      name: "resultados-id-geral"
    }, {
      path: ":id?/questions",
      component: _5764acc6,
      name: "resultados-id-questions"
    }]
  }, {
    path: "/simulados",
    component: _e0fb1656,
    children: [{
      path: "",
      component: _5f9170d0,
      name: "simulados"
    }, {
      path: "simulatedResult",
      component: _5e45d6c3,
      name: "simulados-simulatedResult"
    }, {
      path: "ranking/:id?",
      component: _8ad595b2,
      name: "simulados-ranking-id"
    }]
  }, {
    path: "/suport",
    component: _bf8f319a,
    children: [{
      path: "",
      component: _548d0914,
      name: "suport"
    }, {
      path: "resolved",
      component: _641e2e04,
      name: "suport-resolved"
    }]
  }, {
    path: "/videos",
    component: _d5b30bb0,
    children: [{
      path: "",
      component: _9eae7aaa,
      name: "videos"
    }, {
      path: ":catId/:id?",
      component: _5675f134,
      name: "videos-catId-id"
    }]
  }, {
    path: "/applySimulated/print",
    component: _77e153c0,
    name: "applySimulated-print"
  }, {
    path: "/config/password",
    component: _736b8fb0,
    name: "config-password"
  }, {
    path: "/config/payment",
    component: _755d3a4c,
    name: "config-payment"
  }, {
    path: "/config/perfil",
    component: _66ca8019,
    name: "config-perfil"
  }, {
    path: "/config/payment/card",
    component: _cd24ecf4,
    name: "config-payment-card"
  }, {
    path: "/config/payment/history",
    component: _d25856e4,
    name: "config-payment-history"
  }, {
    path: "/config/payment/:id",
    component: _2b384f37,
    name: "config-payment-id"
  }, {
    path: "/config/payment/:id/unsubscribe",
    component: _49eeabf6,
    children: [{
      path: "",
      component: _520be1f9,
      name: "config-payment-id-unsubscribe"
    }, {
      path: "confirmation",
      component: _cd82e444,
      name: "config-payment-id-unsubscribe-confirmation"
    }, {
      path: "success",
      component: _bc395e2c,
      name: "config-payment-id-unsubscribe-success"
    }]
  }, {
    path: "/applySimulated/:id?",
    component: _cf5a3d26,
    name: "applySimulated-id"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index"
  }, {
    path: "/*",
    component: _3d17928a,
    name: "*"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
